export const rewriteUrl = (
  identifier: string,
  relative: boolean = false,
  provider: string = "mtnews"
): string => {
  const PEBBLE_NEWS_VIEWER = `api/v1/news/providers/${provider}/uuid/`;
  const host = relative && import.meta.env.DEV ? "" : "https://pebble.finance";

  // If identifier already contains any news provider path (not just the current provider)
  // This handles cases where backend returns URLs with source_url_format already applied
  if (
    identifier.includes("api/v1/news/providers/") &&
    identifier.includes("/uuid/")
  ) {
    // Strip the domain if relative is requested
    if (relative && import.meta.env.DEV && identifier.startsWith("https://")) {
      return identifier.replace(/^https?:\/\/[^/]+\//, "/");
    }
    return identifier;
  }

  return `${host}/${PEBBLE_NEWS_VIEWER}${identifier}`;
};
